// BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz
// cookie consent - dölj banner vid accept/decline

(function() {
  function döljBanner(banner) {
    banner.style.display = 'none';
    banner.style.visibility = 'hidden';
    banner.style.opacity = '0';
    banner.style.pointerEvents = 'none';
    banner.classList.add('hidden');
    banner.setAttribute('hidden', '');
    banner.setAttribute('aria-hidden', 'true');
    
    // ta bort body padding
    document.body.style.paddingBottom = '0';
  }

  function hittaBanner() {
    const selektorer = [
      '#shopify-pc__banner',
      '[id*="shopify-pc"]',
      '.shopify-privacy-banner',
      'shopify-privacy-banner',
      'shopify-consent-banner',
      '[class*="cookie-banner"]',
      '[class*="consent-banner"]'
    ];

    for (let i = 0; i < selektorer.length; i++) {
      const element = document.querySelector(selektorer[i]);
      if (element) return element;
    }

    return null;
  }

  function hanteraKnappKlick(event) {
    const knapp = event.currentTarget;
    const text = (knapp.textContent || '').toLowerCase();
    const klass = knapp.className.toLowerCase();
    const id = knapp.id.toLowerCase();

    // kontrollera om det är accept eller decline
    const ärAcceptEllerDecline = 
      text.includes('accept') || 
      text.includes('decline') || 
      text.includes('godkänn') ||
      text.includes('avböj') ||
      klass.includes('accept') || 
      klass.includes('decline') ||
      id.includes('accept') ||
      id.includes('decline');

    if (ärAcceptEllerDecline) {
      const banner = hittaBanner();
      if (banner) {
        // ge shopify tid att spara valet först
        setTimeout(function() {
          döljBanner(banner);
        }, 150);
      }
    }
  }

  function initieraCookieConsent() {
    const banner = hittaBanner();
    
    if (!banner) {
      return;
    }

    // hitta alla knappar i bannern
    const knappar = banner.querySelectorAll('button, a[role="button"], a');
    
    knappar.forEach(function(knapp) {
      // ta bort tidigare lyssnare om de finns
      knapp.removeEventListener('click', hanteraKnappKlick);
      // lägg till ny lyssnare
      knapp.addEventListener('click', hanteraKnappKlick);
    });

    // kontrollera även shadow dom om det finns
    if (banner.shadowRoot) {
      const shadowKnappar = banner.shadowRoot.querySelectorAll('button, a[role="button"], a');
      shadowKnappar.forEach(function(knapp) {
        knapp.removeEventListener('click', hanteraKnappKlick);
        knapp.addEventListener('click', hanteraKnappKlick);
      });
    }

    // observera förändringar i dom för dynamiskt laddade element
    const observer = new MutationObserver(function() {
      const nyttaBanner = hittaBanner();
      if (nyttaBanner && nyttaBanner !== banner) {
        initieraCookieConsent();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // kör när dom är redo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initieraCookieConsent);
  } else {
    initieraCookieConsent();
  }

  // kör även efter fördröjningar för att fånga dynamiskt laddade banners
  setTimeout(initieraCookieConsent, 500);
  setTimeout(initieraCookieConsent, 1500);
  setTimeout(initieraCookieConsent, 3000);
})();
